import { Component } from '@angular/core';

@Component({
  selector: 'app-empty-pagination',
  imports: [],
  templateUrl: './empty-pagination.component.html',
  styleUrl: './empty-pagination.component.scss'
})
export class EmptyPaginationComponent {

}
